/** @prettier */
import { List, Map } from 'immutable';

export const capitalize = (s) =>
  s.substring(0, 1).toLocaleUpperCase() + s.substring(1).toLocaleLowerCase();

export const omit = (originalObj = {}, paths = []) => {
  const obj = {};
  Object.keys(originalObj).reduce((occ, key) => {
    if (!paths.includes(key)) {
      // eslint-disable-next-line no-param-reassign
      occ[key] = originalObj[key];
    }

    return occ;
  }, obj);

  return obj;
};

export const intersection = (arr, ...args) =>
  arr.filter((item) => args.every((array) => array.includes(item)));

export const difference = (arr1, arr2) => arr1.filter((x) => !arr2.includes(x));

export const isEmpty = (collection) => {
  const type = typeof collection;

  switch (type) {
    case 'object':
      if (List.isList(collection) || Map.isMap(collection)) {
        return collection.isEmpty();
      }

      if (Array.isArray(collection)) {
        return !(collection.length > 0);
      }

      return !(Object.keys(collection).length > 0);

    default:
      return true;
  }
};

export const zip = (arr, ...args) =>
  arr.map((value, idx) => [value, ...args.map((array) => array[idx])]);

export const unzip = ([...args]) => zip(...args);

export const escapeRegExp = (string) => {
  const reg = /[[\]{}()*+?.\\^$|]/g;

  return string.replace(reg, '\\$&');
};

// eslint-disable-next-line no-unused-vars
const binarySearch = (sortedArray, key) => {
  let start = 0;

  let end = sortedArray.length - 1;

  while (start <= end) {
    let middle = Math.floor((start + end) / 2);

    if (sortedArray[middle] === key) {
      // found the key, looking for the smallest index

      while (sortedArray[middle - 1] === key) {
        middle -= 1;
      }

      return middle;
    } else if (sortedArray[middle] < key) {
      // continue searching to the right

      start = middle + 1;
    } else {
      // search searching to the left

      end = middle - 1;
    }
  }

  // key wasn't found
  return -1;
};

const binaryIndexSearch = (sortedArray = [], key = '') => {
  let start = 0;

  let end = sortedArray.length - 1;

  let middle;

  while (start <= end) {
    middle = Math.floor((start + end) / 2);

    if (sortedArray[middle] === key) {
      // found the key, looking for the smallest index

      while (sortedArray[middle - 1] === key) {
        middle -= 1;
      }

      return middle;
    } else if (sortedArray[middle] < key) {
      // continue searching to the right

      start = middle + 1;
    } else {
      // search searching to the left

      end = middle - 1;
    }
  }

  // key wasn't found
  return middle;
};

const binaryCheck = (sortedArray = [], key) => {
  if (sortedArray.length === 0) {
    return 0;
  }

  const start = 0;

  const end = sortedArray.length - 1;

  if (key > sortedArray[end]) {
    return end;
  } else if (key <= sortedArray[start]) {
    return start;
  }
  return binaryIndexSearch(sortedArray, key);
};

export const sortedIndex = (array, value) => binaryCheck(array, value);
